// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"4fb7a83f","406":"ce16a850","529":"841e61ec","931":"b430ada6"}[chunkId] + ".chunk.js";
};